import { render } from "./UpdateAlarmComponent.vue?vue&type=template&id=94858138"
import script from "./UpdateAlarmComponent.vue?vue&type=script&lang=js"
export * from "./UpdateAlarmComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__